module.exports = __webpack_public_path__ + "static/media/masjid_kichula10.ebe14099.webp";